export default "__VITE_ASSET__DraPHcSY__"